import { CaseStudyComponent } from '../components/CaseStudyComponent';

export default function PortfolioCeption() {
    return (
        <>
            <CaseStudyComponent slug="portfolioception" />
        </>
    )
}